<template>
<div>
  <q-card  class="lista-proposta-card">
   <q-card-section>
    <div class="text-h5 text-green-14">Proposta do Banco</div>
   </q-card-section>
   <q-card-section>
        <div class="row q-gutter-lg q-pr-md q-pb-md">
           <div class="col-xs-12 col-sm-12 col-md-12">
             <q-table
              :data="data"
              :columns="columns"
              row-key="id"
              selection="single"
              :selected.sync="selected"
              wrap-cells
            ></q-table>
              <!-- <q-option-group
                :options="optionsProposta"
                label="Notifications"
                type="radio"
                v-model="propostaBanco.tipoProposta"
              ></q-option-group> -->
          </div>
        </div>
        <div class="row q-gutter-lg q-pr-md q-pb-md">
            <div class="col-xs-12 col-sm-12 col-md-1">
              <q-btn :loading="loadingConfirmar" color="primary" label="Confirmar" @click="confirmar" />
           </div>
            <div class="col-xs-12 col-sm-12 col-md-2">
              <q-btn  color="red" @click="$router.push({ name: 'home' })" label="Cancelar" />
           </div>
        </div>
   </q-card-section>
 </q-card>

</div>
</template>

<script>
import PropostaBanco from '@/classes/PropostaBanco'
import ConfirmarProposta from '@/classes/ConfirmarProposta'
import EnviaTelefone from '@/classes/EnviaTelefone'
import SmsService from '@/services/sms'
import OperacaoService from '@/services/operacao'
import FormatNumeroCelular from '@/utils/FormatNumeroCelular'
export default {
  data () {
    return {
      propostaBanco: new PropostaBanco(),
      enviaTelefone: new EnviaTelefone(),
      confirmarProposta: new ConfirmarProposta(),
      loadingVerificar: false,
      optionsProposta: [],
      loadingConfirmar: false,
      selected: [],
      columns: [
        { name: 'opcao', align: 'rigth', label: 'Opção', field: 'opcao', sortable: true },
        { name: 'valorOpcao2', align: 'rigth', label: 'Indenização Parcelado (Renda Mensal)', field: 'valorOpcao2', format: valorOpcao2 => this.$b.fCurrency(valorOpcao2), sortable: true },
        { name: 'valorOpcao3', align: 'rigth', label: 'Indenização Parcela Única', field: 'valorOpcao3', format: valorOpcao3 => this.$b.fCurrency(valorOpcao3), sortable: true },
        { name: 'valorPeculio', align: 'rigth', label: 'Indenização em Parcela Única de Benefícios Especiais (Antecipação do Pecúlio)', field: 'valorPeculio', format: valorPeculio => this.$b.fCurrency(valorPeculio), sortable: true },
        { name: 'observacao', align: 'rigth', label: 'Observação', field: 'observacao', sortable: true }
      ],
      data: []
    }
  },
  props: {
    dadosBeneficiario: {
      required: true
    },
    dadosProposta: {
      required: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      OperacaoService.listarOpcoes().then(response => {
        this.data = response.data.data
      })
    },
    confirmar () {
      if (this.selected.length === 0) {
        return this.$b.nWarning('Escolha um tipo de proposta')
      }
      this.propostaBanco.tipoProposta = this.selected[0].id
      console.log(this.dadosProposta)
      this.enviaTelefone.telefone = FormatNumeroCelular(this.dadosProposta.telefoneCelular)
      this.enviaTelefone.identificacaoFiscal = this.dadosBeneficiario.identificacaoFiscal
      this.confirmarProposta.identificacaoFiscal = this.dadosBeneficiario.identificacaoFiscal
      this.confirmarProposta.tipoProposta = this.selected[0].id
      this.loadingConfirmar = true
      console.log(this.propostaBanco)
      OperacaoService.salvaOperacao({ tipoProposta: this.confirmarProposta.tipoProposta }).then(response => {
        this.confirmarProposta.idOperacao = response.data.data.id
        SmsService.enviaTelefone().then(resposta => {
          this.loadingConfirmar = false
          if (resposta.data.status === 'ERROR') {
            return this.$b.nError(resposta.data.message)
          }
          this.$emit('propostaBancoConfirmacao', this.confirmarProposta)
        }).catch((e) => {
          this.loadingConfirmar = false
          return this.$b.nError(e)
        })
      })
    }
  }
}

</script>
